import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import ReactDOMServer from "react-dom/server";
import ClientEmail from "./emailTemplate/ClientEmail";
import { useNavigate } from "react-router-dom";
import { AdvFacReadFromDB } from "../lib/reference";
import thadvFac from "../../pages/thankyou/th-adv-Fac";

export default function AdvocatesAccFactoring({ heading }) {
  const [nameSurename, setNameSurename] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [PracticeTime, setPracticeTime] = useState("");
  const [ValueOfInvoice, setValueOfInvoice] = useState("");
  const [fetchRef, setFetchRef] = useState(false);
  const [refrenceNumber, setRefrenceNumber] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (fetchRef) {
      const fetchRefNumber = async () => {
        try {
          const ref = await getRefNumber();
          setRefrenceNumber(ref);

          // Ensure the reference number is passed in the email function
          setTimeout(() => {
            sendMail({
              nameSurename,
              ValueOfInvoice,
              PracticeTime,
              phoneNumber,
              email,
              refrenceNumber: ref, // Pass the reference number explicitly
            });
          }, 2000);
        } catch (error) {
          console.error("Error fetching reference number:", error);
        }
      };

      fetchRefNumber();
    }
  }, [fetchRef]);

  const getRefNumber = async () => {
    return await AdvFacReadFromDB(); // Update state with the selected value
  };

  function sendMail({
    nameSurename,
    email,
    ValueOfInvoice,
    PracticeTime,
    phoneNumber,
    refrenceNumber,
  }) {
    console.log("Sending Email");

    if (
      nameSurename &&
      email &&
      phoneNumber &&
      PracticeTime &&
      ValueOfInvoice
    ) {
      localStorage.setItem("name", nameSurename);
      localStorage.setItem("email", email);
      localStorage.setItem("tel", phoneNumber);
      localStorage.setItem("PracticeTime", PracticeTime);
      localStorage.setItem("ValueOfInvoice", ValueOfInvoice);
      localStorage.setItem("refrenceNumber", refrenceNumber);

      // Prepare the FormData to include attachments
      const formData = new FormData();
      formData.append(
        "message",
        `Name & Surname: ${nameSurename} <br/> Phone: ${phoneNumber} <br/> Email: ${email}  <br/> Value of Invoice: ${ValueOfInvoice} <br/> Years in Practice: ${PracticeTime} <br/> Refrence: ${refrenceNumber}`
      );
      formData.append("subject", "Advocate Accounts Factoring");
      formData.append("to", "apply@webridge.co.za");
      //formData.append("to", "rudsfoon@gmail.com");

      // Render the ClientEmail component to a string
      const clientEmailHTML = ReactDOMServer.renderToString(
        <ClientEmail refrence={refrenceNumber} name={nameSurename} />
      );
      //send thank you email to client with ref number
      const clientRef = new FormData();
      clientRef.append("message", clientEmailHTML);
      clientRef.append("to", email);
      clientRef.append("name", nameSurename);
      clientRef.append("tel", phoneNumber);
      clientRef.append("PracticeTime", PracticeTime);
      clientRef.append("ValueOfInvoice", ValueOfInvoice);

      clientRef.append("email", email);
      clientRef.append(
        "subject",
        `Advocates Accounts Factoring ${refrenceNumber}`
      );

      // Attach a file if there is one
      const fileInput = document.getElementById("attachment"); // assume there’s an <input type="file" id="attachment">
      if (fileInput && fileInput.files.length > 0) {
        formData.append("attachment", fileInput.files[0]);
        formData.append("attachmentTwo", fileInput.files[0]);
      }
      axios
        .post("https://email-sender-lovat.vercel.app/send_Resend", clientRef, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => alert("Message Sent"))
        .catch(() => alert("Failed to send email"));
      axios
        .post("https://email-sender-lovat.vercel.app/send_Resend", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => alert("Message Sent"))
        .catch(() => alert("Failed to send email"));
      return navigate("/th-adv-Fac");
    }

    return alert("Fill in all fields to continue");
  }

  return (
    <>
      <h6 className=" p-1 m-1">{heading}</h6>
      <form
        method="post"
        onSubmit={(e) => {
          e.preventDefault();
          setFetchRef(true);
        }}
      >
        <input
          type="text"
          className=" form-control"
          placeholder="Name & Surname"
          value={nameSurename}
          onChange={(e) => setNameSurename(e.target.value)}
        />

        <input
          type="email"
          className=" form-control"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="text"
          className=" form-control"
          placeholder="Phone Number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />

        <input
          type="text"
          className=" form-control"
          placeholder="Practice Time (Years)"
          value={PracticeTime}
          onChange={(e) => setPracticeTime(e.target.value)}
        />

        <input
          type="text"
          className=" form-control"
          placeholder="Value of Invoice (R)"
          value={ValueOfInvoice}
          onChange={(e) => setValueOfInvoice(e.target.value)}
        />

        <input type="hidden" value={refrenceNumber} readOnly />

        <button type="submit" className="btn btn-primary">
          Submit
        </button>
      </form>
    </>
  );
}
